module.exports = __webpack_public_path__ + "static/sharptree_horizontal_logo_white-685cf7731054765c959c4e90b2e08444.png";